<template>
  <b-form-group label-size="sm" :id="'field-component-' + objIndex + '-' + editorField.EditorFieldId"
    label-class="font-weight-bold set-overflow"
    :label-cols="hasLabelLeft ? '5' : undefined"
    :label-cols-lg="hasLabelLeft ? '3' : undefined"
    label-for="input-displayname"
    :label-sr-only="labelPosition == 'none'"
    :description="editorField.DisplayDescription"
    :class="{ 'form-group-multi': multiple }"
  >
    <!-- <b-container fluid>
    <b-row no-gutters style="width: 100%;"> -->
    <!-- TODO: sub-item check may not be the best way to hide this -->
    <!-- TODO: subs, this needs to be expandable?? or no? -->
    <template v-slot:label v-if="hasLabel">
      <label class="m-0" @mouseenter="labelHover = true" @mouseleave="labelHover = false">
        {{ displayName }} <span class='text-danger'>{{ (editorField.IsRequired) ? '*' : '' }}</span>
        <b-button-toolbar class="d-inline m-0" :class="{ 'invisible': !labelHover}" v-if="!readOnly">
          <b-button-group size="sm" class="m-0">
            <b-dropdown right text="Field Options" variant="link" v-if="!obj.Created" size="sm">
              <template v-slot:button-content>
                <b-icon icon="three-dots-vertical" variant="info" aria-hidden="true"></b-icon>
              </template>
              <b-dropdown-text
                v-if="changed"
                :title="changed ? 'Original Value' : 'New Value'"
                variant="danger"
                >
                Changed
                <template v-if="popupContent != null && editorField.EditorType != 'checkbox'">
                  {{popupContent}}
                </template>
                <template v-else>
                  {{changed}}
                </template>
              </b-dropdown-text>
              <b-dropdown-text v-else variant="info">
                Unchanged
              </b-dropdown-text>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item variant="info" @click="setDefaultValue()">
                <b-icon icon="arrow-counterclockwise" /> Reset to Default Value: {{getValueText(editorField.DefaultValue)}}
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
            </b-dropdown>
          </b-button-group>
        </b-button-toolbar>
      </label>
    </template>
    <!-- TODO: is this "permissions" or just a checkbox list of some kind I can re-use? -->
    <!-- TODO: how to do @update-data?  @update-data="updateData"  ?-->

    <!-- TODO: figure out how this sub-item or works... -->
    <!-- it is a component that maps to an editor - but directly or via a field? -->
    <!-- for now make a new sub-editor, eh? -->
    <!-- then refactor it out if needed -->
    <component :is="'field-component-' + editorField.EditorType"
      :editorField="editorField"
      :obj="obj" :originalObj="originalObj"
      :parentObj="parentObj" :parentColumn="parentColumn"
      @update-value="(obj, updateColumn, value) => valueUpdated(value)"
      @update-list-value="updateListValue"
      @changed="onChanged" @validated="onValidated" :key="'fieldcomponent-' + editorField.EditorFieldId"
      :fieldCols="fieldCols"
      :multiple="multiple"
      :addChildObject="addChildObject"
      :addChildObjects="addChildObjects"
      :removeChildObject="removeChildObject"
      :readdChildObject="readdChildObject"
      @save="(obj, section) => save(obj, section)"
      :readOnly="readOnly"
      :showAddButton="showAddButton"
    />
    <!-- drops down the list values. doesn't work with every control, but can still exist -->
    <datalist :id="'datalist-' + editorField.EditorFieldId" v-if="editorField.EditorType == 'text'">
      <option v-for="value in editorField.Values" :key="value.EditorFieldValueId">{{ value.Value }}</option>
    </datalist>
    <!-- TODO: make this show the right changes! -->
    <!-- Q: where is real value? -->
    <b-popover
      v-if="editorField.DisplayDescription && editorField.DisplayDescription.length > 0"
      :target="'field-component-' + objIndex + '-' + editorField.EditorFieldId"
      placement="top"
      title="Description"
      triggers="hover"
      >
      {{editorField.DisplayDescription}}
    </b-popover>
    <b-form-invalid-feedback :force-show="!valid">
      <!-- Note: haven't tested with multiple validations... -->
      <div v-for="validation in editorField.Validations" :key="editorField.EditorFieldId + '_' + validation.ValidationType">
        {{validation.ValidationMessage}}
      </div>
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script lang="ts">
import { defineAsyncComponent } from 'vue'
import { EditBase } from '@/store/editor/types'
import { Component, Prop, Mixins } from 'vue-property-decorator'

import MxEditorComponent from '@/mixins/editor-component'
import { EntityBase } from '@/store/types'
import { EditorField } from '@/store/entity/types'
import StatusBadge from '../status-badge.vue'

// TODO: field-component-multi-input-edit
@Component({
  name: 'editor-field',
  components: {
    'field-component-sub-editor-multiple': defineAsyncComponent(() => import('./field-components/sub-editor-multiple.vue')),
    'field-component-sub-editor': defineAsyncComponent(() => import('./field-components/sub-editor.vue')),
    'field-component-multi-input-edit': defineAsyncComponent(() => import('./field-components/multi-input-edit.vue')),
    'field-component-permissions': defineAsyncComponent(() => import('./field-components/permissions.vue')),
    'field-component-checkbox': defineAsyncComponent(() => import('./field-components/checkbox.vue')),
    'field-component-text': defineAsyncComponent(() => import('./field-components/text.vue')),
    'field-component-id': defineAsyncComponent(() => import('./field-components/id.vue')),
    'field-component-password': defineAsyncComponent(() => import('./field-components/password.vue')),
    'field-component-number': defineAsyncComponent(() => import('./field-components/number.vue')),
    'field-component-select': defineAsyncComponent(() => import('./field-components/select.vue')),
    'field-component-none': defineAsyncComponent(() => import('./field-components/none.vue')),
    'field-component-divisions': defineAsyncComponent(() => import('./field-components/divisions.vue')),
    'field-component-associations': defineAsyncComponent(() => import('./field-components/associations.vue')),
    'field-component-modelassociations': defineAsyncComponent(() => import('./field-components/modelassociations.vue')),
    'field-component-image-list': defineAsyncComponent(() => import('./field-components/image-list.vue')),
    'field-component-document-list': defineAsyncComponent(() => import('./field-components/document-list.vue')),
    'field-component-thumbnail': defineAsyncComponent(() => import('./field-components/thumbnail.vue')),
    'field-component-datetime': defineAsyncComponent(() => import('./field-components/datetime.vue')),
    'field-component-image': defineAsyncComponent(() => import('./field-components/image.vue')),
    'field-component-document': defineAsyncComponent(() => import('./field-components/document.vue')),
    'field-component-modeldimensions': defineAsyncComponent(() => import('./field-components/modeldimensions.vue')),
    'field-component-document-link': defineAsyncComponent(() => import('./field-components/document-link.vue')),
    'field-component-order': defineAsyncComponent(() => import('./field-components/order.vue')),
    'field-component-remove': defineAsyncComponent(() => import('./field-components/remove.vue')),
    'field-component-rich-text': defineAsyncComponent(() => import('./field-components/rich-text.vue')),
    // TODO: why is this breaking convention! text-list -> editor-list
    'field-component-editor-list': defineAsyncComponent(() => import('./field-components/editor-list.vue')),
    'field-component-role-permission': defineAsyncComponent(() => import('./field-components/role-permission.vue')),
    'field-component-read-only': defineAsyncComponent(() => import('./field-components/read-only.vue')),
    'field-component-customer-materials': defineAsyncComponent(() => import('./field-components/customer-materials.vue')),
    'status-badge': StatusBadge,
  },
})
export default class extends Mixins(MxEditorComponent) {
  public changed = false

  public valid = true

  public labelHover = false

  public originalValue: any = ''
  public popupContent = ''
  public unwatchOriginal: (() => void) | undefined

  // new!
  @Prop()
  public editorField!: EditorField // the field we're editing

  @Prop()
  public objIndex!: number // the field we're editing

  // So we can hardcode the top label for the Model Editor
  @Prop()
  public labelPosition!: string

  @Prop()
  public fieldCols!: number

  @Prop({ default: true })
  public showAddButton!: boolean

  public mounted() {
    // note: this is for the popup originalValue
    const { editorField, originalObj, propertyName, setOriginalValue } = this
    if (originalObj) {
      setOriginalValue(originalObj[propertyName])
    }
    this.unwatchOriginal = this.$watch('originalObj.' + editorField.EntityProperty.PropertyName, setOriginalValue)
  }

  // the original value was updated - need this for the popover.
  public setOriginalValue(originalValue: any) {
    this.originalValue = originalValue
    this.popupContent = this.getPopupContent()
  }

  public setDefaultValue() {
    const { setDefaultFieldValue, editorField, originalValue } = this
    setDefaultFieldValue(editorField, originalValue)
  }

  get values() {
    // TODO: add value support soon!
    // TODO: not necessary after full refactor!
    return []
  }

  get propertyName() {
    return this.editorField.EntityProperty.PropertyName
  }

  // TODO: get all exceptions here!
  get hasDefault() {
    switch (this.editorField.EditorType) {
      case 'read-only':
      case 'editor-list':
        return false
      default:
        return true
    }
  }

  get hasLabelLeft() {
    if (this.labelPosition !== undefined) { return this.labelPosition === 'left' }

    // TODO: not necessary after full refactor!
    switch (this.editorField.EditorType) {
      case 'text':
      case 'checkbox':
      case 'select':
      case 'permissions':
        return true
      default:
        return false
    }
  }

  get hasLabel() {
    const { labelPosition, displayName } = this
    if (!displayName || displayName.length === 0) { return false }
    if (labelPosition === 'none') { return false }
    switch (this.editorField.EditorType) {
      case 'thumbnail':
      case 'editor-list':
        return false
      default:
        return true
    }
  }

  get displayName() {
    return this.getFieldDisplayName(this.editorField)
  }

  public getPopupContent() {
    const { changed, originalValue } = this
    if (originalValue === undefined) {
      return '[None]'
    }

    if (originalValue === null) {
      return '[NULL]'
    }
    switch (this.editorField.EditorType) {
      case 'text':
      case 'order':
      case 'select':
        return changed ? originalValue : ''
      case 'checkbox':
        return changed ? (originalValue ? 'checked' : 'unchecked') : ''
      // Q: can we build it when we do updateValue and/or changed events?
      case 'multi-input-edit':
      default:
        return null
    }
  }

  public getTitle(entry: EditBase) {
    return this.editorField.PropertyEditor?.EntityObject.titleProperties?.map(c => entry[c.PropertyName]).join(': ') || ''
  }

  // TODO: make different than the other one?
  // this is called from editor-field.vue
  public valueUpdated(value: any) {
    this.$emit('update-value', this.obj, this.editorField, value)
  }

  public updateListValue(i: number, obj: EntityBase, editorField: EditorField, value: any) {
    this.$emit('update-list-value', i, obj, editorField, value)
  }

  public onChanged(changed: boolean) {
    this.changed = changed
    this.popupContent = this.getPopupContent() // we want to the popup if we've changed!

    this.$emit('changed', this.changed)
  }

  public onValidated(valid: boolean) {
    // note: a valid of null for the child component's "state" means don't validate at all (no checkmark orr x)
    //  - but at this level and above, we can treat it as valid
    this.valid = valid === null ? true : valid
    this.$emit('validated', this.valid)
  }
}
</script>
<style scoped>
.form-group {
  margin-bottom: 0!important;
}

.form-group-multi {
  height: 31px;
  overflow: hidden;
}

</style>
<style>
.col-form-label-sm {
  padding-bottom: 0;
  margin-bottom: 0;
  overflow: visible;
}
.button-multi-model-editor {
    width: 120px !important;
    padding: 2px;
    overflow: hidden;
    white-space: nowrap;
  }
</style>
